"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidateTeamsAppArguments = exports.ValidateTeamsAppOptions = void 0;
exports.ValidateTeamsAppOptions = [
    {
        name: "teams-manifest-file",
        questionName: "manifest-path",
        type: "string",
        shortName: "t",
        description: "Specify the path for Teams app manifest template. It can be either absolute path or relative path to the project root folder, with default at './appPackage/manifest.json'",
        default: "./appPackage/manifest.json",
    },
    {
        name: "app-package-file",
        questionName: "app-package-file-path",
        type: "string",
        shortName: "p",
        description: "Specifies the zipped Microsoft Teams app package path, it's a relative path to project root folder, defaults to '${folder}/appPackage/build/appPackage.${env}.zip'",
    },
];
exports.ValidateTeamsAppArguments = [];
//# sourceMappingURL=ValidateTeamsAppOptions.js.map